import styled from "styled-components";
import { motion } from "framer-motion";
import { colors, sizing } from "../../styles/variables.js";

export const Navbar = styled(motion.nav)`
   position: fixed;
   top: 0;
   left: 0;
   z-index: 999;
   box-shadow: 0 1px 4px ${colors.secondary1};
   width: 100%;
   height: 3.6rem;
   background: ${colors.bg};

   .main-container {
      height: 100%;
   }
`;

export const Nav = styled.div`
   display: flex;
   height: 100%;
   align-items: center;
   justify-content: space-around;

   @media (max-width: 800px) {
      justify-content: unset;
   }

   .nav-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: 0.2rem;

      img {
         width: 1.3rem;
         @media (max-width: 600px) {
            width: 1.2rem;
         }
      }
   }
`;

export const NavLinks = styled(motion.ul)`
   height: 100%;
   width: 40%;
   display: flex;
   list-style-type: none;
   justify-content: space-evenly;
   align-items: center;
   cursor: pointer;

   @media (max-width: 800px) {
      display: none;
   }
`;

export const NavLink = styled(motion.li)`
   color: ${colors.primary1};
   font-size: 0.9rem;

   a {
      display: block;
      text-decoration: none;
      color: inherit;
      padding: 0.4rem 1rem;

      &:hover {
         text-decoration: underline;
      }
   }
`;

export const NavToggle = styled.div`
   width: 2.6rem;
   height: 3rem;
   padding: 0 0.4rem;
   display: none;
   cursor: pointer;
   position: relative;

   &.open .long {
      width: 90%;
      top: 8.6px;
      transform-origin: 0;
      transform: rotate(45deg);

      @media (max-width: 500px) {
         top: 4.2px;
      }
   }

   &.open .short {
      width: 90%;
      bottom: 8.6px;
      transform-origin: 0;
      transform: rotate(-45deg);

      @media (max-width: 500px) {
         bottom: 4.2px;
      }
   }

   @media (max-width: 800px) {
      display: block;
   }

   @media (max-width: 500px) {
      width: 2.3rem;
      height: 2.3rem;
   }

   span {
      display: block;
      width: 100%;
      height: 4px;
      border-radius: 10px;
      background: black;
      position: absolute;
      left: 0;
      transition: all 0.15s ease;

      &.long {
         top: 30%;
      }

      &.short {
         width: 70%;
         bottom: 30%;
      }

      @media (max-width: 500px) {
         height: 3px;
      }
   }
`;

export const NavMenu = styled(motion.div)`
   position: absolute;
   top: 120%;
   left: 50%;
   transform: translateX(-50%);
   z-index: 999;

   flex-direction: column;
   justify-content: center;
   width: 90vw;
   padding: 0.5rem 0;

   display: none; /* for mobile */
   box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
   border-radius: 0 ${sizing.borderRadius2} ${sizing.borderRadius2}
      ${sizing.borderRadius2};

   color: ${colors.primary1};
   background: ${colors.bg};

   @media (max-width: 800px) {
      display: flex;
   }

   a {
      text-decoration: none;
      padding: 0.55rem 1.8rem;
      margin: 0.2rem 0.6rem;
      border-radius: ${sizing.borderRadius4};
      font-size: 1.1rem;

      color: inherit;

      transition: background 0.3s ease-in-out;

      &:hover {
         background: ${colors.secondary3};
      }
   }
`;
